import React from 'react'
import { FiChevronRight } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'
import SpinningIcon from '../Template/SpinningIcon'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const Button = styled.div<{ sent?: boolean } & IWithSize>`
  border-radius: 4px;
  display: flex;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  color: white;
  font-weight: bold;
  padding: ${({ size }) => (size ? 2 * size : 2)}px
    ${({ size }) => (size ? 7 * size : 7)}px;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  ${isNot('sent')`
  cursor: pointer;
  `}
  ${is('sent')`
    background-color: #afafaf
  `}
  &:hover {
    ${isNot('sent')`
    background-color: #008735;
    `}
  }
`

function ActionButton({ label, action, sending = null, style = {}, size = 1 }) {
  return (
    <Flex
      justifyEnd={true}
      alignStart={true}
      style={{ ...{ marginTop: `${10}px` }, ...style }}
    >
      <Button size={size} onClick={action} sent={sending === 2}>
        <div style={{ opacity: sending === 1 ? 0 : 1 }}>{label}&nbsp;</div>
        {sending === 1 && <SpinningIcon style={{ position: 'absolute' }}/>}
        {!(sending === 1) && !(sending === 2) && <FiChevronRight/>}
      </Button>
    </Flex>
  )
}

export default ActionButton
